import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../services/jrni/api.service';
import { DatastoreService } from '../services';
import { AvailabilityService } from '../services/jrni/availability.service';
import moment from 'moment';

@Component({
  selector: 'app-cost-breakdown-vat',
  templateUrl: './cost-breakdown-vat.component.html',
  styleUrls: ['./cost-breakdown-vat.component.scss'],
})
export class CostBreakdownVatComponent implements OnInit {
  @Input() costBreakDown: any;
  @Input() company: any;
  @Input() service: any;
  @Input() currentPage: any;
  ceremonyDateId: number;
  date: string;
  ceremonyDate: any;
  showBudgetCode = false;
  // fees: any = [];
  totalCost: any;
  daysAway: any = 0;
  costTotal: any = 0;
  adminJourney: boolean = false;
  depositTotal: any = 0;
  // True when /fees answered 404: this booking has no configured price and
  // must not be bookable online. It is NOT free.
  feesUnavailable = false;

  constructor(
    private apiService: ApiService,
    public dataStore: DatastoreService,
    private availabilityService: AvailabilityService
  ) {}

  ngOnInit(): void {
    // if currentPage is "/summary" then show budget code
    if (this.currentPage === '/summary' && this.dataStore.adminJourney) {
      this.showBudgetCode = true;
    }

    if (this.dataStore.adminJourney) {
      this.adminJourney = true;
    }

    this.dataStore.addFees$.subscribe((feeToAdd) => {
      if (feeToAdd) {
        this.dataStore.vatSplit = this.dataStore.vatSplit.filter(
          (item) => item.questionid !== feeToAdd.questionid
        );

        this.dataStore.vatSplit.push({
          questionid: feeToAdd.questionid,
          item: feeToAdd.item,
          quantity: feeToAdd.quantity,
          cost: feeToAdd.cost,
          deposit: feeToAdd.cost,
          budget_code: feeToAdd.payment_code,
          vat: 'Non-VAT',
          type: 'extra'
        });
        this.calculateTotal();
      }
    });

    if (!this.company) {
      this.company = this.dataStore.selectedDepartment;
    }

    if (!this.service) {
      this.service = this.dataStore.selectedService;
    }
    this.calculate().catch((error) => {
      // /fees could not price this (404 = missing fee row; reason logged by the
      // api service). Never fall through to a £0 breakdown: flag the journey as
      // unpriced so the template explains and the summary refuses checkout.
      console.error('cost-breakdown: unpriced — blocking online checkout', error);
      this.feesUnavailable = true;
      this.dataStore.feesUnavailable = true;
      this.dataStore.serviceFees = [];
    });
  }

  async calculate() {
    this.feesUnavailable = false;
    this.dataStore.feesUnavailable = false;
    const slot = await this.availabilityService.getSelectedSlot();
    console.log(slot);
    if (slot) {
      this.date = moment(slot.start).format('YYYY-MM-DD HH:mm:ss');
      this.daysAway = moment(slot.start).diff(moment(), 'd');
    }

    // if (this.ceremonyDate) {
    //   this.daysAway = moment(this.ceremonyDate).diff(moment(), 'd')
    // }

    if (this.date) {
      const fee: any = await this.apiService.fees(
        this.company.id,
        this.date,
        this.service.id,
        this.service.calculated_duration
      );

      const foundNonVatSplit = this.dataStore.vatSplit.find((v) => v.item === this.service.name && v.vat === 'Non-VAT');
      const foundVatSplit = this.dataStore.vatSplit.find((v) => v.item === this.service.name && v.vat === 'Standard-VAT');
      if (!foundNonVatSplit && !foundVatSplit) {
        if (this.daysAway > 182) {
          // if deposit
          this.dataStore.vatSplit.push({
            // push deposit non vat
            questionid: fee['questionid'],
            item: this.service.name,
            quantity: 1,
            cost: fee['dep_vat_n'],
            deposit: fee['deposit'],
            budget_code: fee['payment_code'],
            vat: 'Non-VAT',
            type: 'service'
          });

          this.dataStore.vatSplit.push({
            // show standard deposit vat
            questionid: fee['questionid'],
            item: this.service.name,
            quantity: 1,
            cost: fee['dep_vat_s'],
            deposit: fee['deposit'],
            budget_code: fee['payment_code'],
            vat: 'Standard-VAT',
            type: 'service'
          });
        } else {
          this.dataStore.vatSplit.push({
            // push full non vat
            questionid: fee['questionid'],
            item: this.service.name,
            quantity: 1,
            cost: fee['full_vat_n'],
            deposit: fee['deposit'],
            budget_code: fee['payment_code'],
            vat: 'Non-VAT',
            type: 'service'
          });

          this.dataStore.vatSplit.push({
            // show standard full vat
            questionid: fee['questionid'],
            item: this.service.name,
            quantity: 1,
            cost: fee['full_vat_s'],
            deposit: fee['deposit'],
            budget_code: fee['payment_code'],
            vat: 'Standard-VAT',
            type: 'service'
          });
        }

        if (fee.short_notice > 0) {
          if (
            this.service.extra?.hasOwnProperty('fees_extra_item_short_notice_id')
          ) {
            const extraItemShortNoticeId =
              this.service.extra.fees_extra_item_short_notice_id;
            const extraItem: any = await this.apiService.getExtraItem(
              this.company.id,
              this.service.id,
              extraItemShortNoticeId
            );
            console.log(extraItem);
            this.dataStore.vatSplit.push({
              questionid: 'noid1',
              item: extraItem.item_name,
              quantity: 1,
              cost: extraItem.item_price,
              deposit: extraItem.item_price,
              item_id: extraItemShortNoticeId,
              budget_code: extraItem.data.short_code,
              vat: 'Non-VAT',
              type: 'extra'
            });
          }
        }

        if (fee.out_of_hours > 0) {
          // get the day
          let extraItemOutOfHoursId: any = false;
          const dayOfWeek = moment(this.date).format('ddd');
          if (fee.is_bank_holiday || dayOfWeek === 'Sun') {
            if (
              this.service.extra?.hasOwnProperty(
                'fees_extra_item_out_of_hours_sun_bank_hol_id'
              )
            ) {
              extraItemOutOfHoursId =
                this.service.extra.fees_extra_item_out_of_hours_sun_bank_hol_id;
            }
          } else {
            if (
              this.service.extra?.hasOwnProperty(
                'fees_extra_item_out_of_hours_mon_sat_id'
              )
            ) {
              extraItemOutOfHoursId =
                this.service.extra.fees_extra_item_out_of_hours_mon_sat_id;
            }
          }
          if (extraItemOutOfHoursId) {
            const extraItem: any = await this.apiService.getExtraItem(
              this.company.id,
              this.service.id,
              extraItemOutOfHoursId
            );
            console.log(extraItem);
            this.dataStore.vatSplit.push({
              questionid: 'noid2',
              item: extraItem.item_name,
              quantity: 1,
              cost: extraItem.item_price,
              deposit: extraItem.item_price,
              item_id: extraItemOutOfHoursId,
              budget_code: extraItem.data.short_code,
              vat: 'Non-VAT',
              type: 'extra'
            });
          }
        }
      }
    }

    this.calculateTotal();
  }

  calculateTotal() {
    let costTotal = 0;
    let depositTotal = 0;
    costTotal = this.dataStore.vatSplit.reduce(
      (sum, fee) => sum + fee.cost * fee.quantity,
      0
    );
    if (this.daysAway > 182) {
      this.totalCost = this.dataStore.vatSplit.reduce(
        (sum, fee) => sum + fee.deposit * fee.quantity,
        0
      );
      depositTotal = this.dataStore.vatSplit.reduce(
        (sum, fee) => sum + fee.deposit * fee.quantity,
        0
      );
    } else {
      this.totalCost = this.dataStore.vatSplit.reduce(
        (sum, fee) => sum + fee.cost * fee.quantity,
        0
      );
    }
    this.dataStore.vatSplit = this.dataStore.vatSplit.sort(
      (a, b) => b.cost - a.cost
    );
    // this.dataStore.totalCost = this.totalCost;
    this.costTotal = costTotal;
    this.depositTotal = depositTotal;
    console.log('costTotal', costTotal, 'depositTotal', depositTotal);
  }
}
